import { createFileRoute } from '@tanstack/react-router'
import { SuccessPage } from '@/pages/auth/login/SuccessChangePassPage'

export const Route = createFileRoute('/auth/success-change-pass')({
  component: SuccessPage,
})
